import { render, staticRenderFns } from "./client-unit-departament-form.vue?vue&type=template&id=d0cde2e6&scoped=true&lang=pug&"
import script from "./client-unit-departament-form.vue?vue&type=script&lang=ts&"
export * from "./client-unit-departament-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cde2e6",
  null
  
)

export default component.exports